import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Project from "../views/Project.vue";
import ProjectEPOS from "../views/ProjectEpos.vue";
import ProjectTimeline from "../views/ProjectTimeline.vue";
import PrivacyPolicy from "../views/PrivacyPolicy.vue";
import SmartHome from "../views/SmartHome.vue";
import Viewer3d from "../views/Viewer3d.vue";
import Project3d from "../views/Project-3d.vue"

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/project/:slug",
    name: "Project",
    component: Project
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () =>
    //   import(/* webpackChunkName: "about" */ "../views/Project.vue")
  },
  {
    path: "/project-epos/:slug",
    name: "Project EPOS",
    component: ProjectEPOS
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () =>
    //   import(/* webpackChunkName: "about" */ "../views/Project.vue")
  },
  {
    path: "/project-3d/:slug",
    name: "Project-3d",
    component: Project3d
  },
  {
    path: "/etapele-lucrarii",
    name: "ProjectTimeline",
    component: ProjectTimeline
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () =>
    //   import(/* webpackChunkName: "about" */ "../views/ProjectTimeline.vue")
  },
  {
    path: "/smart-home",
    name: "SmartHome",
    component: SmartHome
  },
  {
    path: "/3d",
    name: "Viewer3d",
    component: Viewer3d
  },
  {
    path: "/privacypolicy",
    name: "PrivacyPolicy",
    component: PrivacyPolicy
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () =>
    //   import(/* webpackChunkName: "about" */ "../views/PrivacyPolicy.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior() {
    document.getElementById("app").scrollIntoView({ behavior: "instant" });
    // if (to.hash) {
    //   console.log(to.query.cta);
    //   return { selector: to.hash };
    // }
  }
});

router.beforeEach((to, from, next) => {
  // console.log(to);
  if (!to.query.lang) {
    var setLocale = from.query.lang || "ro";
    to.query.lang = setLocale;
    next({ path: to.path, query: to.query });
  } else {
    next();
  }
});

export default router;
